// Portrait photos for Book Club, discovered at build time: drop a square
// head-and-shoulders portrait (jpg/png/webp, ~400px) into women/ or men/ and it
// joins the pool. The folder decides which first names the person can be
// given; file names are never shown. Each entry is {id, src, presentation}.
const load = (ctx, presentation) =>
  ctx.keys().map((key) => ({
    id: `${presentation}/${key.split("/").pop()}`,
    src: ctx(key),
    presentation,
  }));

const all = [
  ...load(require.context("./women", false, /\.(jpe?g|png|webp)$/i), "f"),
  ...load(require.context("./men", false, /\.(jpe?g|png|webp)$/i), "m"),
];

// webpack can list the same file under more than one key; keep one of each.
const FACES = all.filter((face, i) => all.findIndex((f) => f.id === face.id) === i);

export default FACES;
